import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { DxDataGridComponent } from 'devextreme-angular';
import { Company } from "../../model/shared.model";
import { PlantOwnershipService } from "./plant-ownership.service";
import { CompanySite } from "src/app/plant/types/CompanySite";

@Component({
    selector: 'plant-ownership',
    templateUrl: './plant-ownership.component.html',
    styleUrls: ['./plant-ownership.component.scss']
})

export class PlantOwnershipComponent implements OnChanges {
    @ViewChild("CompanyGrid", { static: false }) companyGrid: DxDataGridComponent;
    @ViewChild("CompanyOwnershipGrid", { static: false }) companyOwnershipGrid: DxDataGridComponent;
    @Input() buttonTrigger: boolean;
    @Input() siteId: number;
    @Input() siteType: string = "Merchant";
    @Input() companySites: CompanySite[];
    @Output() setLoadPanelVisibility: EventEmitter<boolean> = new EventEmitter();
    @Output() setPopupVisibility: EventEmitter<boolean> = new EventEmitter();
    @Output() setSiteId: EventEmitter<number> = new EventEmitter();
    @Output() setCompanySites: EventEmitter<CompanySite[]> = new EventEmitter();
    @Output() createCompanySiteForNewSite: EventEmitter<boolean> = new EventEmitter();
    readonly allowedPageSizes = [50, 100, 200];
    title: string;
    popupVisible: boolean;
    disableAddBtn: boolean;
    disableDeleteBtn: boolean;
    isLoadPanelVisible: boolean = false;
    siteInfoResponseReceived: boolean;
    showPercentageOwnerErrorMsg: boolean;
    companyList: Company[];
    originalCompanySites: CompanySite[];
    decimalOnePlace: any = /^\d*(\.\d{1,1})?$/;
    companyName: string;
    showCompanyErrorMsg: boolean;
    showMultiNationalCompanies: boolean;
    companySiteItemRemoved: boolean;
    isCancel: boolean;

    constructor(private siteOwnershipService: PlantOwnershipService, private notificationService: NotificationService) {
        this.title = 'Choose Site'
        this.popupVisible = false;
        this.showCompanyErrorMsg = false;
        this.disableAddBtn = true;
        this.disableDeleteBtn = true;
        this.showMultiNationalCompanies = false;
        this.isCancel = false;
        this.companyList = [];
        this.originalCompanySites = []
    }

    ngOnChanges(changes: SimpleChanges) {
        var that = this;
        if (changes['buttonTrigger'] && changes['buttonTrigger']?.previousValue != changes['buttonTrigger']?.currentValue) {
            this.popupVisible = changes['buttonTrigger']?.currentValue;
            if (this.popupVisible) this.openPopup();
        }

        if (this.companySites && !this.isCancel) {
            this.companySites = this.companySites.filter(item => item.companyName !== 'Total');
            that.originalCompanySites = [];
            this.companySites.forEach(function (value) {
                let companySite = new CompanySite();
                companySite.companyId = value.companyId;
                companySite.companyName = value.companyName;
                companySite.siteId = value.siteId;
                companySite.companyOwnerSharePercent = value.companyOwnerSharePercent;
                if (that.originalCompanySites) that.originalCompanySites.push(companySite);
            });
        }
    }

    searchCompanies() {
        this.isLoadPanelVisible = true;
        this.showCompanyErrorMsg = (!(this.companyName && this.companyName.length >= 3) && !this.showMultiNationalCompanies);
        if (this.showMultiNationalCompanies && !this.companyName)
            this.companyName = '';
        if (this.showCompanyErrorMsg && !this.showMultiNationalCompanies) {
            this.isLoadPanelVisible = false;
            return;
        }

        try {
            this.siteOwnershipService.getCompanies(this.companyName, this.siteType, this.showMultiNationalCompanies).subscribe(data => {
                if (data) {
                    this.companyList = data;
                    this.removeAlreadyAddedCompany();
                    this.isLoadPanelVisible = false;
                }
            },
                error => {
                    this.notificationService.alert("error", "Error occured while fetching the companies", error);
                    this.isLoadPanelVisible = false;
                });
        }
        catch (e) {
            this.notificationService.alert("error", "Error occured while fetching the companies", null);
            this.isLoadPanelVisible = false;
        }
    }

    openPopup() {
        this.popupVisible = true;
        this.isCancel = false;
    }

    closePopup(totalpercent) {
        this.companyName = '';
        this.companyList = [];
        this.showMultiNationalCompanies = false;
        this.companyGrid.instance.clearFilter();
        if (this.companySites && this.companySites.length > 0)
            this.companySites.push({ companyName: "Total", companyOwnerSharePercent: totalpercent, companyId: 0, siteId: 0 });
        this.setPopupVisibility.emit(false);
    }

    addCustomerSite() {
        var data = this.companyGrid.instance.getSelectedRowsData()[0];
        let companySite = new CompanySite();
        companySite.companyId = data.companyId;
        companySite.companyName = data.companyName;
        companySite.companyOwnerSharePercent = 0;
        if (this.companySites) this.companySites.push(companySite);
        this.companyOwnershipGrid.instance.refresh();
        this.companyList = this.companyList.filter(item => item.companyId !== companySite.companyId);
    }

    removeCustomerSite() {
        var data = this.companyOwnershipGrid.instance.getSelectedRowsData()[0];
        let company = new Company();
        company.companyId = data.companyId;
        company.companyName = data.companyName;
        if (this.companyList) this.companyList.push(company);
        this.companySites = this.companySites.filter(item => item.companyId !== company.companyId);
    }

    companiesSelectionChangedHandler(e: any) {
        this.disableAddBtn = this.companyGrid.selectedRowKeys.length < 1;
    }


    companyOwnSelectionChangedHandler(e: any) {
        this.disableDeleteBtn = this.companyOwnershipGrid.selectedRowKeys.length < 1;
    }

    onCellDblClick(e) {
        if (e.columnIndex == 1) e.component.editRow(e.row.rowIndex);
    }

    removeAlreadyAddedCompany() {
        if (this.companySites) {
            var that = this;
            this.companySites.forEach(function (value) {
                that.companyList = that.companyList.filter(item => item.companyId !== value.companyId);
            });
        }
    }

    getTotalOwnership(): number {
        this.showPercentageOwnerErrorMsg = false;
        let totalpercent = 0.0;
        this.companySites.forEach(element => {
            totalpercent += Number(element.companyOwnerSharePercent);
        });
        return totalpercent;
    }

    onClickCancel() {
        this.isCancel = true;
        if (this.isCancel) {
            this.companySites = this.originalCompanySites;
            this.setCompanySites.emit(this.companySites);
        }
        this.closePopup(this.getTotalOwnership());
    }

    onSaving(isClosePopup: boolean) {
        var total = this.getTotalOwnership();
        if (this.getTotalOwnership() != 100.0) {
            this.showPercentageOwnerErrorMsg = true;
            return;
        }

        this.isLoadPanelVisible = true;
        var that = this;
        this.companySites.forEach(function (value) {
            value.siteId = that.siteId;
        });

        this.createCompanySiteForNewSite.emit(true);
        this.isLoadPanelVisible = false;
        this.notificationService.alert("warning", "Company Site ownership data captured successfully but kindly note it will not be saved until the site information is saved", null);
        this.setCompanySites.emit(this.companySites);
        that.originalCompanySites = [];
        this.companySites.forEach(function (value) {
            let companySite = new CompanySite();
            companySite.companyId = value.companyId;
            companySite.companyName = value.companyName;
            companySite.companyOwnerSharePercent = value.companyOwnerSharePercent;
            if (that.originalCompanySites) that.originalCompanySites.push(companySite);
        });

        if (isClosePopup) this.closePopup(total);
        return;
    }

    addNewOwner() {
        this.companyGrid.instance.addRow();
    }

    saveCompany(event: any) {
        let company = new Company();

        if (event.data) {
            company.companyName = event.data.companyName;
            company.companyType = event.data.companyType;
        }
        else {
            company.companyId = event.key;
            company.companyName = event.newData.companyName ?? event.oldData.companyName;
            company.companyType = event.newData.companyType ?? event.oldData.companyType;
        }
        this.siteOwnershipService.saveCompany(company).subscribe(data => {
            if (data) {
                this.isLoadPanelVisible = false;
                var isNewCompany = !company.companyId;
                if (!company.companyId) {
                    company.companyId = data;
                    let savedCompany = this.companyList[this.companyList.length - 1];
                    savedCompany.companyId = data;
                }
                if (isNewCompany)
                    this.notificationService.alert("success", "New company added successfully", null);
                else
                    this.notificationService.alert("success", "Company details updated successfully", null);
            }
        },
            error => {
                this.companyList = this.companyList.filter(x=> !isNaN(x.companyId));
                this.notificationService.alert("error", "Error occured while saving the company information", error);
                this.isLoadPanelVisible = false;
            });
    }
}
